import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogModule, MatDialogTitle } from "@angular/material/dialog";
import { CommonModule } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-dialog-status",
  imports: [MatDialogModule, CommonModule, MatIcon, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, MatButtonModule],
  templateUrl: "./dialog-status.html",
  styleUrl: "./dialog-status.less",
  standalone: true,
})
export class DialogStatus {
  title!: string;
  message!: string;
  icon!: string;
  iconClass!: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.title = data.title || "Aviso";
    this.message = data.message || "";
    this.icon = this.getIcon(data.type);
    this.iconClass = this.getIconClass(data.type);
  }

   private getIcon(type: string): string {
    switch (type) {
      case 'success': return 'check_circle';
      case 'error': return 'error';
      case 'info': return 'info';
      case 'warning': return 'warning';
      default: return 'info';
    }
  }

  private getIconClass(type: string): string {
    switch (type) {
      case 'success': return 'text-success';
      case 'error': return 'text-error';
      case 'info': return 'text-info';
      case 'warning': return 'text-warning';
      default: return 'text-info';
    }
  }
}
